"use client";

import Content from "../Content";
import Featured from "../Featured";
import { notFound } from "next/navigation";
import { ContentComponent, FeaturedComponent } from "@/types/modules";
import FreeText from "../FreeText";
import styles from "@/styles/modules/pages/pages/page.module.scss";
import { Page } from "@/types/wordpress";
import { useLanguageUrl } from "@/context/languageURLContext";
import { useEffect } from "react";

interface PagesComponentProps {
  data: Page;
}

export default function PagesComponent({ data }: PagesComponentProps) {
  const { setUrl } = useLanguageUrl(); // Access context values
  // New variable to modify the URI based on the presence of "/de/"
  const originalUri = data.translations[0].uri;
  const modifiedUri = originalUri.includes("/de/")
    ? originalUri.replace(/(\/[^\/]*\/)/, "$&pages/") // Add "pages/" after the second "/" if it contains "/de/"
    : `/pages${originalUri}`; // Add "/pages/" at the beginning if it doesn't contain "/de/"

  useEffect(() => {
    setUrl(modifiedUri);
  }, [modifiedUri, setUrl]);

  if (data === null) {
    notFound();
  } else if (data.template.templateName === "Default") {
    return (
      <main>
        <section className={styles.pageContent}>
          <div className={styles.pageContentContainer}>
            {data.content && <FreeText content={data.content} />}
          </div>
        </section>
      </main>
    );
  } else if (data.template.templateName === "Content") {
    const featured: FeaturedComponent = {
      backgroundColor: data.template.featured!.backgroundColor,
      title: data.template.featured!.title,
      custom: data.template.featured!.custom,
    };

    const content: ContentComponent = {
      imageAlign: data.template.contentFields!.imageAlign,
      textAlign: data.template.contentFields!.textAlign,
      content: data.template.contentFields!.body,
      gallery: data.template.contentFields!.gallery,
      sameWidth: true,
      ...(data.template.contentFields!.title && {
        title: data.template.contentFields!.title,
      }),
    };

    return (
      <main>
        <section className={styles.pageContentContent}>
          <div className={styles.pageContentContentContainer}>
            <Content content={content} />
          </div>
        </section>
        <Featured featured={featured} />
      </main>
    );
  }

  notFound();
}
